// Angular
import { HttpClient } from '@angular/common/http';
// Service
import { TranslateLoader } from '@ngx-translate/core';
import { of } from 'rxjs';
// Third Party
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { catchError, map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {

  constructor(private http: HttpClient,
    public resources: { prefix: string, suffix: string, fileName: string }[]) { }

  /**
 * Gets the translations from the server
 * @param lang
 * @returns {any}
 */
  public getTranslation(lang: string): any {
    /* English is loaded too (template-02 parity): the en/*.json files carry wording overrides,
       e.g. "Are you sure you want to claim this reward?" → "Would you like to claim this reward?".
       Browser only: 'en' is also `fallbackLang`, so on the server an async English load makes
       every SSR render (all languages) hang and never respond. template-02 has no SSR. */
    if (lang.toLowerCase() === 'en' && typeof window === 'undefined') {
      return of({});
    }
    return forkJoin(this.resources.map(config => {
      return this.http.get(`${config.prefix}${lang.toLowerCase()}/${config.fileName}${config.suffix}`);
    })).pipe(
      map(response => {
        return response.reduce((a, b) => {
          return Object.assign(a, b);
        });
      }),
      catchError(() => {
        return of({});
      })
    )
  }
}